// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"5d1cf2f8","91":"5e7a075f","245":"4ca8f074","338":"3aac7f58","479":"280e9000","515":"29914248","688":"42b9c769","710":"b4da6434","775":"0ba9a500","886":"280e9000","887":"fc637903","960":"fc4e4af2"}[chunkId] + ".chunk.css";
};